<template>
    <div class="page-content">
        <div class="page-head">
            <div class="page-head-content">
                <el-form label-position="top" inline>
                    <el-form-item label="类型">
                        <el-select style="width: 160px;" v-model="type">
                            <el-option v-for="item in typeList" :key="item.id" :label="item.name"
                                       :value="item.id"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="航班号">
                        <el-input placeholder="请输入航班号" style="width: 160px;" v-model="searchForm.flight"></el-input>
                    </el-form-item>
                    <el-form-item label="城市">
                        <el-select style="width: 160px;" v-model="searchForm.area" filterable>
                            <el-option v-for="item in cityList" :key="item.id" :label="item.name"
                                       :value="item.id"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="接机时间" prop="time">
                        <el-date-picker
                                style="width: 180px"
                                v-model="searchForm.time"
                                value-format="yyyy/MM/dd HH:mm"
                                format="yyyy/MM/dd HH:mm"
                                type="datetime"
                                placeholder="选择接机时间">
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item label="人数">
                        <el-select v-model="searchForm.people" placeholder="请选择人数" filterable style="width: 160px">
                            <el-option v-for="(item,index) in numAry"
                                       :key="index"
                                       :label="`${item}人`"
                                       :value="item"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item style="margin-top: 50px;">
                        <el-button type="primary" :loading="loading" @click="handlerSearch">搜索</el-button>
                    </el-form-item>
                </el-form>
            </div>
            <div class="page-head-content">
                <el-form label-position="right" inline>
                    <el-form-item>
                        <el-select v-model="sort">
                            <el-option v-for="item in sortList" :key="item.id" :label="item.name"
                                       :value="item.id"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="价格范围">
                        <el-input style="width: 90px;" placeholder="最小价格" v-model="min"></el-input>
                        <span style="margin: 0 4px;">-</span>
                        <el-input style="width: 90px;" placeholder="最大价格" v-model="max"></el-input>
                    </el-form-item>
                </el-form>
            </div>
        </div>
        <div class="search-content">
            <div class="search-body">
                <ShuttleCard v-for="item in newList" @reserve="handlerReserve(item)" :key="item.id"
                             :item="item"></ShuttleCard>
            </div>
            <div class="search-right">
                <img src="./../assets/img/chose.png" class="right-content-img" alt="">
                <div class="right-btn f-18 color-fff cur-p" @click="toIssue">发布需求</div>
                <div class="right-content">
                    <div class="right-title ml-20">预约流程</div>
                    <img class="right-content-img" style="width: 276px;" src="./../assets/img/liucheng.png" alt="">
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapState} from 'vuex'
    import ShuttleCard from "../components/ShuttleCard";

    export default {
        name: "shuttleResult",
        components: {ShuttleCard},
        data() {
            return {
                loading: false,
                type: 1,
                currentType: 1,
                typeList: [
                    {id: 1, name: '接机'},
                    {id: 2, name: '送机'}
                ],
                numAry: Array.from({length: 15}, (item, index) => index + 1),
                searchForm: {
                    flight: '',
                    site: '',
                    time: '',
                    people: 1,
                    airport: '',
                    area: '',
                },
                sortList: [
                    {id: 1, name: '推荐排序'},
                    {id: 2, name: '好评优先'},
                    {id: 3, name: '低价优先'},
                    {id: 4, name: '高价优先'},
                ],
                sort: 1,
                min: '',
                max: '',
                list: []
            }
        },
        computed: {
            ...mapState(['cityList']),
            newList() {
                let ary = []
                let min = this.min * 1;
                let max = this.max * 1;
                if (this.sort === 1) {
                    ary = this.list.sort(this.compare('stars', 1))
                } else if (this.sort === 2) {
                    ary = this.list.sort(this.compare('stars', 1))
                } else if (this.sort === 3) {
                    ary = this.list.sort(this.compare('price', 0))
                } else if (this.sort === 4) {
                    ary = this.list.sort(this.compare('price', 1))
                }
                return ary.filter(item => {
                    if (min && max) {
                        return item.price * 1 >= min && item.price * 1 <= max
                    } else if (min && !max) {
                        return item.price * 1 >= min
                    } else if (!min && max) {
                        return item.price * 1 <= max
                    } else {
                        return true
                    }
                })
            }
        },
        created() {
            let {
                type,
                flightNum,
                area,
                airport_select,
                destination,
                time,
                population,
                luggage
            } = JSON.parse(decodeURIComponent(this.$route.query.data))
            this.type = type;
            this.currentType = type;
            this.searchForm.flight = flightNum;
            this.searchForm.site = destination;
            this.searchForm.airport = airport_select;
            this.searchForm.time = time;
            this.searchForm.people = population;
            this.searchForm.luggage = luggage;
            this.searchForm.area = area;
            this.driverCarSlip()
        },
        methods: {
            handlerSearch() {
                this.currentType = this.type;
                this.driverCarSlip()
            },
            async driverCarSlip() {
                this.loading = true;
                let [e, data] = await this.$api.driverCarSlipApi(this.searchForm);
                this.loading = false;
                this.list = Object.values(data.result);
            },
            compare(property, num) { //排序  0表示从小到大，1表示从大到小
                return (a, b) => {
                    var val1 = +a[property];
                    var val2 = +b[property];
                    if (num === 0) {
                        return val1 - val2
                    } else {
                        return val2 - val1
                    }
                }
            },
            toIssue() {
                let params = {type: this.currentType, ...this.searchForm}
                this.$router.push({
                    path: '/shuttleReservation',
                    query: {params: encodeURIComponent(JSON.stringify(params))}
                })
            },
            handlerReserve(item) {
                let params = {...item, ...this.searchForm, type: this.currentType};
                this.$store.commit('saveShuttlePayInfo', params);
                this.$router.push({path: '/shuttlePay'})
            }
        }
    }
</script>

<style scoped lang="less">
    .page-head {
        background-color: #ffffff;
        border-bottom: 1px solid #e2e2e2;

        .page-head-content {
            width: 1200px;
            display: flex;
            justify-content: flex-start;
            align-items: center;
            margin: auto;
        }
    }

    .search-content {
        display: flex;
        justify-content: flex-start;
        align-items: flex-start;
        width: 1200px;
        margin: auto;
        padding: 20px 0;
        box-sizing: border-box;

        .search-body {
            width: 900px;
            margin-right: 20px;
            box-shadow: 3px 3px 6px #A6A6A6;
            background-color: #ffffff;
        }
    }

    .search-right {
        position: sticky;
        top: 100px;
        z-index: 2;

        .right-btn {
            width: 100%;
            height: 50px;
            line-height: 50px;
            text-align: center;
            background-color: #e44646;
            margin-top: 16px;
        }

        .right-content {
            box-shadow: 3px 3px 6px #A6A6A6;
            /*padding: 20px;*/
            width: 100%;
            box-sizing: border-box;
            background-color: #ffffff;
            margin-top: 20px;

        }

        .right-title {
            padding: 10px 20px;
            margin-bottom: 0;
        }

        .right-content-img {
            width: 100%;
            object-fit: contain;
        }
    }
</style>
